/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { DeleteOpenDialogButtonComponent } from '@administration-client/shared';
import { User } from '@administration-client/user-shared';
import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StateResource } from '@common/tech-shared';
import { DIALOG_COMPONENT, SpinnerComponent } from '@odc/component';
import { Observable, tap } from 'rxjs';
import { UserFormDataComponent } from './user-form-data/user-form-data.component';
import { UserDeleteDialogContainerComponent } from './user-form-delete-dialog-container/user-delete-dialog-container.component';
import { UserFormHeadlineComponent } from './user-form-headline/user-form-headline.component';
import { UserFormOrganisationsEinheitListComponent } from './user-form-organisations-einheit-list/user-form-organisations-einheit-list.component';
import { UserFormRolesComponent } from './user-form-roles/user-form-roles.component';
import { UserFormSaveButtonComponent } from './user-form-save-button/user-form-save-button.component';
import { UserFormService } from './user.formservice';

@Component({
  selector: 'administration-user-form',
  providers: [UserFormService, { provide: DIALOG_COMPONENT, useValue: UserDeleteDialogContainerComponent }],
  templateUrl: './user-form.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    AsyncPipe,
    SpinnerComponent,
    UserFormDataComponent,
    UserFormRolesComponent,
    UserFormOrganisationsEinheitListComponent,
    UserFormHeadlineComponent,
    UserFormSaveButtonComponent,
    DeleteOpenDialogButtonComponent,
  ],
})
export class UserFormComponent implements OnInit {
  public readonly formService = inject(UserFormService);

  public userStateResource$: Observable<StateResource<User>>;
  public isPatch: boolean;
  public userName: string;
  public submitStateResource$: Observable<StateResource<User>>;

  ngOnInit(): void {
    this.userStateResource$ = this.formService.get().pipe(
      tap(() => {
        this.isPatch = this.formService.isPatch();
        this.userName = this.formService.getUserName();
      }),
    );
  }

  public submit(): void {
    this.submitStateResource$ = this.formService.submit();
  }
}
